import React, { useState } from "react";
import layer from "../../Asset/productdetail/layer.png";
import { IoIosStar } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";


import ratingModel from "../../model/rating.model";
import { toast } from "../../lib/helper";

const RatingReview = ({ datalist }) => {
  
  console.log("fffff review", datalist);
  return (
    <div className="w-full">
      <div className="flex gap-4">
        <div>
          <img src={layer} alt="img" />
        </div>
        <div className="flex flex-col">
          <span
            className="text-3xl text-textColor font-bold cursor-pointer"
            
          >
            Rating & Reviews
          </span>
          <div className="flex gap-2 items-center">
            <IoIosStar className="text-yellow-300 text-lg" />
            <span>{datalist?.rating} out of 5 Star</span>
          </div>
        </div>
      </div>
      <div className="w-full mt-10">
        <div className="p-4 bg-white rounded-xl text-textColor">
          <div className="flex gap-2 items-center text-sm">
            <FaRegUser /> <span>By Chitransh G</span>
          </div>
          <span className="font-bold">Very good quality</span>
          <span className="w-full flex flex-wrap text-wrap">
            Very good product.  My suggestion is to take care of your heart
            health & use genuine refined oil always for cooking purposes. 👍
          </span>
        </div>
      </div>
     
    </div>
  );
};

export default RatingReview;
